import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

interface BrivoRefreshTokenErrorModalProps {
    isOpen: boolean;
    message: string;
    onClose: () => void;
}

const BrivoRefreshTokenErrorModal: React.FC<BrivoRefreshTokenErrorModalProps> = ({ isOpen, message, onClose }) => {
    return (
        <Modal isOpen={isOpen} toggle={onClose} className="custom-modal">
            <ModalHeader toggle={onClose}>Error</ModalHeader>
            <ModalBody>
                <p>{message}</p>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={onClose}>Close</Button>
            </ModalFooter>
        </Modal>
    );
};

export default BrivoRefreshTokenErrorModal;



// WEBPACK FOOTER //
// ./src/components/pages/admin/BrivoRefreshTokenErrorPopup.tsx